import { render, staticRenderFns } from "./escopo-select.vue?vue&type=template&id=15e89e36&scoped=true&"
import script from "./escopo-select.vue?vue&type=script&lang=js&"
export * from "./escopo-select.vue?vue&type=script&lang=js&"
import style0 from "./escopo-select.vue?vue&type=style&index=0&id=15e89e36&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e89e36",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15e89e36')) {
      api.createRecord('15e89e36', component.options)
    } else {
      api.reload('15e89e36', component.options)
    }
    module.hot.accept("./escopo-select.vue?vue&type=template&id=15e89e36&scoped=true&", function () {
      api.rerender('15e89e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/escopo-select/escopo-select.vue"
export default component.exports